import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'HomepageBooking',
    component: () => import("../views/HomepageBooking.vue"),
  },
  {
    path: '/booking',
    name: 'HomepageBooking2',
    component: () => import("../views/HomepageBooking.vue"),
  },
  {
    path: '/henvis-kunde',
    name: 'HenvisKunde',
    component: () => import("../views/HenvisKunde.vue"),
  },
  {
    path: '/5R',
    name: '5R',
    component: () => import("../views/5R.vue"),
  },
  {
    path: '/intern',
    name: 'InternForm',
    component: () => import("../views/Intern.vue"),
  },
  {
    path: '/DMF',
    name: 'DMF',
    component: () => import("../views/DMF.vue"),
  },
  {
    path: '/HOC',
    name: 'HOC',
    component: () => import("../views/HOC.vue"),
  },
  {
    path: '/Soderberg',
    name: 'SoderbergForm',
    component: () => import("../views/Soderberg.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router
